import { createFileRoute, Outlet } from '@tanstack/react-router'
import EnvironmentLayout from '@/layouts/EnvironmentLayout'

export const Route = createFileRoute('/$workspaceName/$environment')({
  component: EnvironmentLayoutRoute,
})

function EnvironmentLayoutRoute() {
  return (
    <EnvironmentLayout>
      <Outlet />
    </EnvironmentLayout>
  )
}
